import { React, useEffect } from "react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

import { Button } from "../../commonComponents/Buttons";

import { useLockBodyScroll } from "../../../hooks";

import "./uploadedModal.scss";

function UploadedModal({ uploadType, percentage }) {
  useLockBodyScroll();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (percentage === 100) {
      setTimeout(function () {
        navigate(-1);
      }, 5000);
    }
  }, [percentage, navigate]);

  return (
    <>
      <section className="modalBg">
        <section className="modalBody uploadedModal">
          <div className="dialog-header">
            <h3 className="heading-3">
              {uploadType !== "video"
                ? t("successfullyUploadedSubmission")
                : t("pleaseWait")}
            </h3>
            {uploadType !== "video" && (
              <legend>{t("successfullyUploadedSubmissionLegend")}</legend>
            )}
          </div>

          {uploadType === "video" && (
            <>
              <div className="modal-upload-progress">
                <CircularProgressbar
                  value={percentage}
                  text={`${percentage}%`}
                  className={
                    percentage === 100
                      ? "finished-upload"
                      : "in-progress-upload"
                  }
                />
              </div>
              <p className="video-upload-text">
                {t("videoUploadWarningModal")}
              </p>
            </>
          )}

          <div className="buttons dialog-footer">
            {uploadType !== "video" && (
              <Button
                label={t("ok")}
                viewType="mainBtn"
                onClick={() => navigate(-1)}
              />
            )}
          </div>
        </section>
      </section>
    </>
  );
}

export default UploadedModal;
